import React from 'react';

// EQG-MOB-00 §4.2/§5 — white spine-and-chip card. Status is a 3px left spine
// plus a chip, NEVER a card fill. Pass `spine="var(--overdue)"` etc. for status.
const MobileCard = ({
  children,
  className = '',
  onClick,
  variant = 'default',
  padding = 'normal',
  spine,
  ...rest
}) => {
  const variantStyles = {
    default: 'bg-[var(--surface-card)] border-[var(--border)]',
    warning: 'bg-[var(--due-bg)] border-[var(--due-edge)]',
    danger: 'bg-[var(--critical-bg)] border-[var(--critical-edge)]',
    success: 'bg-[var(--pass-bg)] border-[var(--pass-edge)]',
    info: 'bg-[var(--neutral-bg)] border-[var(--neutral-edge)]',
    active: 'bg-[var(--volt-tint)] border-[var(--volt-edge)]',
  };

  const paddingStyles = {
    none: '',
    small: 'p-3',
    normal: 'p-4',
    large: 'p-5',
  };

  // Spine cards are always white; the accent lives in a 3px inset bar.
  const surface = spine ? 'bg-[var(--surface-card)] border-[var(--border)]' : variantStyles[variant];
  const boxShadow = spine
    ? `inset 3px 0 0 ${spine}, var(--elev-raised)`
    : 'var(--elev-raised)';

  return (
    <div
      onClick={onClick}
      {...rest}
      className={`
        rounded-[13px] border overflow-hidden transition-[background-color,border-color,transform]
        ${surface}
        ${paddingStyles[padding]}
        ${onClick ? 'cursor-pointer active:scale-[0.98] hover:border-[var(--border-strong)]' : ''}
        ${className}
      `}
      style={{ boxShadow }}
    >
      {children}
    </div>
  );
};

export default MobileCard;
